const options = {
  5: "bg-indigo-500/5",
  10: "bg-indigo-500/10",
  25: "bg-indigo-500/25",
  50: "bg-indigo-500/50",
  75: "bg-indigo-500/75",
  90: "bg-indigo-500/90",
  100: "bg-indigo-500",
};

const from = {
  5: "from-indigo-500/5",
  10: "from-indigo-500/10",
  25: "from-indigo-500/25",
  50: "from-indigo-500/50",
  75: "from-indigo-500/75",
  90: "from-indigo-500/90",
  100: "from-indigo-500",
};

export default function getBackgroundIndigo500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
  